import React from 'react';
import PageHeaderClient from './PageHeaderClient';

type Props = {
  title: string;
  centered?: boolean;
};

export default function PageHeader(props: Props) {
  return <PageHeaderClient {...props} />;
}
